module.exports = __webpack_public_path__ + "static/media/5.26dd45a4.png";